// eslint-disable-next-line complexity
export default function currentBrowser(): 'Firefox' | 'Opera' | 'IE' | 'Edge' | 'Chromium' | 'Safari' | 'Unknown' {
  const sUsrAg = navigator.userAgent

  if (sUsrAg.includes('Firefox')) {
    return 'Firefox'
  }
  if (sUsrAg.includes('Opera')) {
    return 'Opera'
  }
  if (sUsrAg.includes('Trident')) {
    return 'IE'
  }
  if (sUsrAg.includes('Edge')) {
    return 'Edge'
  }
  if (sUsrAg.includes('Chrome')) {
    return 'Chromium'
  }
  if (sUsrAg.includes('Safari')) {
    return 'Safari'
  }
  return 'Unknown'
}
